import { getField,updateField } from "vuex-map-fields";
import * as actions from "./actions";
import mutations from "./mutation";

export default {
    namespaced:true,
    state:{
        isLoading:false,
        showMessage:false,
        isSuccess:false,
        message:"",
        isLogin:false,
        item:null

    },
    actions,
    getters:{
        getField
    },
    mutations:{
        updateField,
        ...mutations
    }
}